export default __webpack_public_path__ + "static/media/coche-hidrogeno.1b3cb6bd.jpg";